import React from "react";
import { Row, Col } from "reactstrap";
import { getErrors } from "./index";

export const getSectionData = (data) =>
  data &&
  data.map((row, index) => (
    <Row key={index}>
      {row.map(
        (
          { component: Component, custom, children, ...componentOpts },
          index,
        ) => (
          <Col {...custom} key={index}>
            <Component {...componentOpts}>{children}</Component>
          </Col>
        ),
      )}
    </Row>
  ));

export const checkValidation = (oldState, newState, fieldName, rules, fn) => {
  if (oldState[fieldName] !== newState[fieldName]) {
    getErrors(newState, rules)[fieldName]
      ? fn({ [fieldName]: false })
      : fn({ [fieldName]: true });
  }
};
